export default function Footer() {
  return (
    <footer className="border-t border-zinc-800 mt-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <span className="w-2 h-2 bg-red-600" />
            <span className="font-display text-lg uppercase tracking-tight">Asylum<span className="text-red-600">.</span></span>
          </div>
          <p className="text-xs text-zinc-500 leading-relaxed">
            Independent music distribution built for the underground and the industry.
          </p>
        </div>
        <div>
          <div className="text-[10px] tracking-[0.2em] uppercase text-zinc-500 mb-3">Product</div>
          <div className="flex flex-col gap-2 text-sm">
            <a href="/pricing" className="hover:text-red-500 transition-colors">Pricing</a>
            <a href="/#platforms" className="hover:text-red-500 transition-colors">Platforms</a>
            <a href="/how-it-works" className="hover:text-red-500 transition-colors">How It Works</a>
            <a href="/compare" className="hover:text-red-500 transition-colors">vs DistroKid &amp; TuneCore</a>
          </div>
        </div>
        <div>
          <div className="text-[10px] tracking-[0.2em] uppercase text-zinc-500 mb-3">Company</div>
          <div className="flex flex-col gap-2 text-sm">
            <a href="/#roster" className="hover:text-red-500 transition-colors">Roster</a>
            <a href="https://www.instagram.com/asylumdistro" target="_blank" rel="noopener noreferrer" className="hover:text-red-500 transition-colors">Instagram</a>
            <a href="https://www.tiktok.com/@asylumdistro" target="_blank" rel="noopener noreferrer" className="hover:text-red-500 transition-colors">TikTok</a>
            <a href="https://www.facebook.com/asylumdistro" target="_blank" rel="noopener noreferrer" className="hover:text-red-500 transition-colors">Facebook</a>
          </div>
        </div>
        <div>
          <div className="text-[10px] tracking-[0.2em] uppercase text-zinc-500 mb-3">Legal</div>
          <div className="flex flex-col gap-2 text-sm">
            <a href="#" className="hover:text-red-500 transition-colors">Terms</a>
            <a href="#" className="hover:text-red-500 transition-colors">Privacy</a>
            <a href="#" className="hover:text-red-500 transition-colors">DMCA</a>
          </div>
        </div>
      </div>
      <div className="border-t border-zinc-800 px-6 lg:px-10 py-4 flex items-center justify-between text-xs text-zinc-600">
        <span>© 2026 Asylum Entertainment. All rights reserved.</span>
        <span className="tracking-[0.2em] uppercase">Made for artists</span>
      </div>
    </footer>
  );
}
